export default __webpack_public_path__ + "static/media/597.a41aea05.png";